var _rect, _rect2, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCensuszenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 28,
    height: 36,
    rx: 4,
    stroke: "#0D9488",
    strokeWidth: 2.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0,
    width: 14,
    height: 8,
    rx: 3,
    fill: "#0D9488"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24,
    r: 8,
    stroke: "#0F766E",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24 Q18 18 22 24",
    stroke: "#0F766E",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 32,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#1a1a2e",
    letterSpacing: -0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0D9488"
  }, "Census"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#1a1a2e"
  }, "Zen"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensuszenLogo);
export default __webpack_public_path__ + "static/media/censuszen-logo.6361e45378d518afeab231bb03cbf9e3.svg";
export { ForwardRef as ReactComponent };